import React, { Component } from "react";
import { Map, GoogleApiWrapper, Marker, InfoWindow } from "google-maps-react";
import { getImage } from "gatsby-plugin-image";
import { fontColorDark } from "./shared.module.scss";
import { getYardiPropId, getYardiPropIdFromSlug } from "../utils/propertyMapUtil";
import { getRentDisplay } from "../utils/helperFunctions";
import { getFindigsUrlBySlug } from "../utils/findigsLinks";
import { navigate } from "gatsby";

class GoogleMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // InfoWindow state
      showingInfoWindow: false,
      activeMarker: {},
      selectedPlace: {},

      // Single toggle to show/hide ALL POI
      showAllPOI: false,
    };
  }

  onMarkerClick = (props, marker, e) =>
    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true,
    });

  /**
   * Build the Google Map styles based on a single checkbox toggle.
   * This will hide/show ALL Points of Interest (poi).
   */
  getDynamicMapStyles = () => {
    const baseMapStyles = [
      {
        featureType: "water",
        elementType: "geometry",
        stylers: [{ color: "#e9e9e9" }, { lightness: 17 }],
      },
      {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [{ color: "#f5f5f5" }, { lightness: 20 }],
      },
    ];
    return [
      ...baseMapStyles,
      {
        featureType: "poi",
        stylers: [
          { visibility: this.state.showAllPOI ? "on" : "off" },
        ],
      },
    ];
  };

  render() {
    // Build marker data
    const markers = [];
    this.props.nodes.forEach((n, id) => {
      markers.push({
        id: id,
        lat: n.exactLocation.lat,
        lng: n.exactLocation.lon,
        communityName: n.communityName,
        image: n.hero
          ? getImage(n.hero.gatsbyImageData).images.fallback.src
          : "",
        address: n.address,
        email: n.email,
        phone: n.phone,
        rmpropid: n.rmpropid,
        beds: n.maxBeds,
        hours: n.shortHours,
        area: n.area.toLowerCase(),
        citySlug: n.citySlug,
        slug: n.slug,
      });
    });

    // Container and map styling
    const containerStyle = {
      width: "100%",
      height: "100%",
    };
    const mstyle = {
      maxWidth: "850px",
      height: "100%",
    };

    // Custom marker icons
    const markerStyles = {
      url: "/imgs/m-blue.png",
      size: new this.props.google.maps.Size(32, 32),
      scaledSize: new this.props.google.maps.Size(32, 32),
      anchor: new this.props.google.maps.Point(16, 16),
    };

    const activeMarkerStyles = {
      url: "/imgs/m-yellow.png",
      size: new this.props.google.maps.Size(32, 32),
      scaledSize: new this.props.google.maps.Size(32, 32),
      anchor: new this.props.google.maps.Point(16, 16),
    };


    return (
      <div>
        {/* 
          SINGLE CHECKBOX CONTROL
          ---------------------------------------------
          This toggles ALL POIs on/off
        */}
        <div style={{ marginBottom: "1rem" }}>
          <label>
            <input
              type="checkbox"
              checked={this.state.showAllPOI}
              onChange={() =>
                this.setState({ showAllPOI: !this.state.showAllPOI })
              }
            />{" "}
            Show Points of Interest
          </label>
        </div>

        {/* 
          GOOGLE MAP
          ---------------------------------------------
        */}
        <Map
          /** 
           *  The key prop below forces the Map to unmount/remount when showAllPOI changes,
           *  ensuring updated styles are reliably re-applied.
           */
          key={this.state.showAllPOI ? "show-poi" : "hide-poi"}
          google={this.props.google}
          zoom={this.props.zoom ? this.props.zoom : 10}
          initialCenter={{
            lat: this.props.lat,
            lng: this.props.long,
          }}
          onDragend={this.props.isViewed}
          onZoomChanged={this.props.isViewed}
          containerStyle={containerStyle}
          style={mstyle}
          // Pass our dynamically-built style array
          styles={this.getDynamicMapStyles()}
        >
          {markers.map((marker) => (
            <Marker
              key={marker.id}
              position={{ lat: marker.lat, lng: marker.lng }}
              onClick={this.onMarkerClick}
              name={marker.communityName}
              email={marker.email}
              phone={marker.phone}
              hours={marker.hours}
              beds={marker.beds}
              rmpropid={marker.rmpropid}
              slug={marker.slug}
              area={marker.area}
              citySlug={marker.citySlug}
              image={marker.image}
              icon={
                this.state.selectedPlace.name === marker.communityName ||
                this.props.hoveringOver === marker.communityName
                  ? activeMarkerStyles
                  : markerStyles
              }
            />
          ))}
          <InfoWindow
            marker={this.state.activeMarker}
            visible={this.state.showingInfoWindow}
          >
            <div>
              <img
                src={this.state.selectedPlace.image}
                alt={"Image of " + this.state.selectedPlace.name}
                style={{ maxWidth: "200px" }}
              />
              <h1 className={fontColorDark + " is-size-4"}>
                {this.state.selectedPlace.name}
              </h1>
              <p className={fontColorDark}>
                <a href={`mailto:${this.state.selectedPlace.email}`}>
                  email us
                </a>
              </p>
              <p className={fontColorDark}>
                {this.state.selectedPlace.phone}
              </p>
              <p className={fontColorDark}>
                {this.state.selectedPlace.beds === "1"
                  ? "1 bedroom"
                  : `1 - ${this.state.selectedPlace.beds} bedroom`}
              </p>
              <p className={fontColorDark}>
                {getRentDisplay(
                  this.state.selectedPlace,
                  this.props.priceRange,
                  this.props.proformaRange,
                  getYardiPropId
                )}
              </p>
              <br />
              <p>
              <a
                href={`/apartments/${this.state.selectedPlace.area}/${this.state.selectedPlace.citySlug}/${this.state.selectedPlace.slug}/`}
                target="_blank"
                rel="noopener noreferrer"
                className="button is-small is-link"
              >
                View Community
              </a>
                &nbsp;
                <a
                  href={`${getFindigsUrlBySlug(getYardiPropIdFromSlug(this.state.selectedPlace.slug))}&source=apply_gmaps`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="button is-small is-warning"
                  onClick={(e) => e.stopPropagation()}
                >
                  Apply Now
                </a>
              </p>
            </div>
          </InfoWindow>
        </Map>
      </div>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: "AIzaSyAvmUR7D1oDWNyl0mdASlkl6RqTwVef4_c",
})(GoogleMap);
